<template>
  <aha-modal
    hideHeader
    :size="modalSize"
    classes="ai-modal"
    boxShadow="0 0 1px 8px rgba(255,255,255,0.3)"
    @hide="handleCloseModal()"
  >
    <AISlideGeneratorSideLeft
      isModalContent
      @closeModal="handleCloseModal()"
      :isGeneratorContentVisible="slideGenerator.isAISlideGeneratorModalVisible"
      @changeAIModalSize="handleChangeAIModalSize"
    />
  </aha-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import AISlideGeneratorSideLeft from '@/components-v2/presentation-editor/new-slide/OpenAI/AISlideGeneratorSideLeft.vue'

export default {
  components: {
    AISlideGeneratorSideLeft,
  },
  data() {
    return {
      modalSize: '3xl',
    }
  },
  computed: {
    ...mapState({
      slideGenerator: (state) => state.slideGenerator,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    ...mapActions(['setShowAISlideGeneratorModalAction']),
    handleCloseModal() {
      this.setShowAISlideGeneratorModalAction(false)
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'AI Quiz Generator > Close',
        null,
        null,
        {
          presentationId: this.presentation.id,
          touchPoint: this.slideGenerator.gaTouchPointWhenOpenAIModal ?
            this.slideGenerator.gaTouchPointWhenOpenAIModal : 'Create new slide modal',
        },
      )
    },

    handleChangeAIModalSize(size) {
      this.modalSize = size
    },
  },
}
</script>
